<template>
    <v-autocomplete
        v-model="data"
        :items="options"
        :item-text="field"
        :item-value="value"
        :label="placeholder"
        color="primary"
        clearable
        outlined
        small-chips
        chips
        deletable-chips
        multiple
        :dense="dense"
        hide-details
        :menu-props="{closeOnContentClick:true}"
    >
    </v-autocomplete>
</template>

<script>
export default {
  name: 'MultiplySelect',
  props: [
    'model',
    'options',
    'field',
    'value',
    'dense',
    'placeholder',
  ],
  data() {
    return {
    };
  },
  computed:{
    data: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      }
    },
  },
  methods: {
    updateOptions(content) {
      this.$emit('update:model', this.model);
    },
  },
};
</script>

<style>

</style>
